module.exports = __webpack_public_path__ + "img/矩形 2515.75b1ae94.png";